import { render } from "./About.vue?vue&type=template&id=e032cc1a&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/jh8oh.github.io/jh8oh.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__